import { apiService } from '@/api/apiService';
import { ApiResponseType } from '@/types/sharedTypes';

export const inviteRecipientApi = (
  token: string,
  contact: string
): Promise<ApiResponseType<{ invited: boolean; contact: string }>> =>
  apiService.POST(`/recipient-requests/${token}/invite/`, { contact });
